
import searchFormMixin from '@/mixins/search-form-mixin';
import staticId from '~/mixins/static-id';
export default {
    mixins: [searchFormMixin, staticId],
    computed: {
        getHidePriceForGuests() {
            return this.$store?.state?.global?.globalSettings?.hide_price_for_guests && !this.$store?.state?.auth?.isAuth;
        },
        isClient() {
            return process.client;
        }
    }
};
